import TYPES from '../../action-types';
import convertAssetToMatchData from '../../helpers/assets/convertAssetToMatchData';
import Logger from '../../../services/Logger';

const selectAllByMatch = () => (dispatch, getAll) => {
  const { items } = getAll().assets;
  Logger.log('User', 'BMMSelectAllToolbarClicked', { selectedCount: items.length });
  dispatch({
    type: TYPES.ASSETS.SELECT_ALL_BY_MATCH,
    payload: {
      selectedAssetsData: items.map((item) => convertAssetToMatchData(item)),
    },
  });
  window.dispatchEvent(new Event('selection:switched:on'));
};

export default selectAllByMatch;
